import { useCallback } from 'react';
import { useActor } from '@xstate/react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { useBagIds } from '../../../../hooks';
import { useReorderNavigation } from '../useReorderNavigation';
import { logger } from '../utils';

export const useCancelReorder = () => {
  const { reorderMachineRef } = useGlobalAppState();
  const [state, sendReorderEvent] = useActor(reorderMachineRef);
  const { bagRestaurantSlug, bagAddressId } = useBagIds();
  const { dismissReorder, dismissReorderNewMenu, dismissReorderHome } =
    useReorderNavigation();

  return useCallback(
    (options?: CancelReorderOptions) => {
      // ─── State Machine ──────────────────────────────────────────
      sendReorderEvent('CANCEL_REORDER');

      // ────────────────────────────────────────────────────────────

      if (options?.dismissToHome) {
        logger.info('Cancel Reorder to Home');
        dismissReorderHome();

        return;
      }

      if (options?.dismissToBagMenu) {
        logger.info('Cancel Reorder to Bag Menu');
        dismissReorderNewMenu(bagRestaurantSlug, bagAddressId);

        return;
      }

      if (options?.dismissToSelectedMenu) {
        logger.info('Cancel Reorder to Selected Menu');
        dismissReorderNewMenu(
          state.context.restaurantSlug,
          state.context.deliveryOrderDetail?.addressId,
        );

        return;
      }

      // ─── Dismiss without extra navigation ───────────────────────
      logger.info('Cancel Reorder without extra navigation');
      dismissReorder();
    },
    [
      state.context.restaurantSlug,
      state.context.deliveryOrderDetail?.addressId,
      bagRestaurantSlug,
      bagAddressId,
      sendReorderEvent,
      dismissReorder,
      dismissReorderNewMenu,
      dismissReorderHome,
    ],
  );
};

type CancelReorderOptions = Readonly<{
  dismissToSelectedMenu?: boolean;
  dismissToBagMenu?: boolean;
  dismissToHome?: boolean;
}>;
